const QUALITYREPORTAPI = {
  POSTQUALITYREPORT: (data) => `qualityReport/${data}`,
  GETQUALITYREPORT: `qualityReport`,
  GETONEQUALITYREPORT: (data) => `qualityReport/${data}`,
};

export default QUALITYREPORTAPI;
